import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.07 2.842c-1.66 0-3.144.806-4.07 2.044a5.09 5.09 0 0 0-4.07-2.044c-2.814 0-5.097 2.291-5.097 5.124 0 1.09.174 2.099.477 3.034 1.448 4.583 5.913 7.324 8.122 8.076.311.11.825.11 1.136 0 2.21-.752 6.674-3.493 8.122-8.076a9.8 9.8 0 0 0 .477-3.034c0-2.833-2.283-5.124-5.097-5.124"
    }, null, -1)
  ]))]))
}
export default { render: render }